<template>
  <div class="wrap-content wrap-overview wrap-bg f-tal">
    <div class="list-filter-wrap-box">
      <v-list-filter
        v-model="bindForms"
        :form-arr="formArr"
        :form-rules="formRules"
        :is-add-btn="false"
        form-item-position="row"
        class="list-filter bg-white"
        @changeFormBind="changeFormBind" />
    </div>
    <div class="wrap-main-content">
      <core-indicators
        v-loading="isLoading[0]"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        :list='indicatorsList'
        :tip-txt="titleTxt[0].tipTxt"
        title="核心指标"
        class="pd15 bg-white mg-top15 " />
      <div class="pd15 bg-white mg-top15 volumnTrend">
        <v-title :tip-txt="titleTxt[1].tipTxt" title="声量趋势" />
        <div class="f-pr">
          <div class="f-pa volumn-filter-box">
            <v-list-filter
              v-model="volumnBindValue"
              :form-arr="volumnFormArr"
              :is-add-btn="false"
              form-item-position="row"
              class="volumn-list-filter bg-white"
              @changeFormBind="volumnChange" />
          </div>
          <div
            id="volumn-tren-line-chart"
            v-loading="isLoading[1]"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            class="chart-box mg-top20 volumn-tren-line-chart"
          ></div>
        </div>
      </div>
      <!--产线分析-->
      <div class="pd15 bg-white mg-top15">
        <v-title :tip-txt="titleTxt[2].tipTxt" title="产线分析">
          <div class="f-df f-ai pd-right15">
            <label>排序指标：</label>
            <!--排序指标-->
            <el-select
              v-model="pageObj.sortIndex"
              placeholder="请选择"
              style="width: 140px;"
              @change="getList()">
              <el-option
                v-for="(elem, i) in sortIndex"
                :key="i"
                :label="elem.name"
                :value="elem.id" />
            </el-select>
            <!--排序顺序-->
            <el-select
              v-model="pageObj.sortRule"
              placeholder="请选择"
              style="width: 100px;"
              class="mg-left10"
              @change="getList()">
              <el-option
                v-for="(elem, i) in sortRules"
                :key="i"
                :label="elem.name"
                :value="elem.id" />
            </el-select>
          </div>
        </v-title>
        <v-table-list
          :is-loading="isLoading[2]"
          :table-head="tableHead"
          :page-list="pageList"
          :current-page="pageObj.page"
          :page-size="pageObj.pageSize"
          :total-size="pageObj.totalSize"
          :is-show-selection="false"
          :is-table-operation-btn="false"
          class="bg-white pd-row15"
          @sizeChange="sizeChange"
          @currentChange="currentChange" />
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page.config.js'
import vListFilter from '@/components/form-filter/index.vue'
import coreIndicators from './components/core_indicators.vue'
import vTitle from '@/components/vTitle.vue'
import vTableList from '@/components/table-list.vue'
import $filterCommon from '@/components/form-filter/index.js'
import mixin from '@/views/analysis/analysis.js'
import {
  getMassCore,
  getVoiceTrend,
  getSortLabel,
  getList,
  getListTotal
} from '@/api/analysis/overview.js'
export default {
  components: {
    vListFilter,
    vTitle,
    vTableList,
    coreIndicators
  },
  mixins: [mixin],
  data() {
    return {
      isLoading: [false, false, false],
      titleTxt: pageConfig.titleTxt,
      bindForms: {},
      formArr: [],
      formRules: {},
      brankList: [], // 品牌列表
      indicatorsList: [], // 核心指标
      volumnFormArr: [], // 声量趋势
      volumnBindValue: {}, // 声量趋势
      tableHead: [], // 表头
      pageList: [], // 产线分析数据
      overSearchStr: [],
      sortIndex: [],
      sortRules: pageConfig.sortRules,
      pageObj: {
        page: 1,
        pageSize: 10,
        totalSize: 0,
        sortIndex: '', // issue_date按发布时间排序，impl_date按实施时间排序
        sortRule: '1' // 1倒序，2升序
      }
    }
  },
  created() {
  },
  mounted() {
    // 核心指标
    this.indicatorsList = JSON.parse(JSON.stringify(pageConfig.indicatorsList))
    // 产线分析
    this.tableHead = JSON.parse(JSON.stringify(pageConfig.tableHead))
    // 获取排序指标
    this.getSortLabel()
    // 开始初始化
    this.init()
  },
  methods: {
    init() {
      // 请求所有条件
      const filterAjaxList = JSON.parse(JSON.stringify(pageConfig.filterAjaxList))
      Promise.all(filterAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        // 获取品牌列表
        const brandObj = data.find(item => item.id === 'brand') || {}
        this.brankList = brandObj.data || []
        // 表单
        const formArr = JSON.parse(JSON.stringify(pageConfig.filterForm))
        // 初始化所有筛选条件集合
        const filterObj = $filterCommon.filterChooseHandle(formArr, data)
        // 初始化当前选择的筛选条件
        const $storeFilter = this.$store.state.platParam
        this.bindForms = Object.assign(filterObj.filterChooseObj, $storeFilter)
        this.formArr = filterObj.filterList
        // 声量趋势
        this.volumnInit()
        // 默认时间初始化，如果$store存在默认时间选择，优先选择，否则默认初始化的时间
        const timeChooseItem = this.formArr.find(item => item.id === ($storeFilter.timeType ? 'timeType' : 'dateMonth')) || {}
        // 页面统一请求初始化并且请求
        this.changeFormBind(this.bindForms, timeChooseItem, $storeFilter.timeType || this.bindForms[timeChooseItem.intValue])
        // // 页面统一请求初始化并且请求
        // const timeChooseItem = this.formArr.find(item => item.id === 'dateMonth') || {}
        // this.changeFormBind(this.bindForms, timeChooseItem, this.bindForms[timeChooseItem.intValue])
      })
    },
    // 初始化
    volumnInit() {
      const formArr = JSON.parse(JSON.stringify(pageConfig.volumnFormArr))
      // 加入对比下拉树形赋值
      const compareItem = formArr.find(item => item.id === 'searchStr') || {}
      if (this.brankList) {
        compareItem.children.forEach(item => {
          item.children = JSON.parse(JSON.stringify(this.brankList))
        })
      }
      // 加入对比默认值赋值
      const treeBrandFirst = compareItem.children[0]
      const brandId = treeBrandFirst.children.length ? treeBrandFirst.children[0].id : ''
      const compareInitVals = [treeBrandFirst.id, brandId]
      if (this.$store.state.platParam && this.$store.state.platParam.brand && compareInitVals.length > 1) {
        compareInitVals[1] = this.$store.state.platParam.brand
      }
      compareItem.intValue = [compareInitVals]
      // 初始化所有筛选条件集合
      const filterObj = $filterCommon.filterChooseHandle(formArr, [])
      // 初始化当前选择的筛选条件
      this.volumnBindValue = filterObj.filterChooseObj
      this.volumnFormArr = filterObj.filterList
    },
    // 页面各个模块总入口请求
    pageTotalAjax(bindForms = {}, item = {}, value) {
      // 核心指标接口
      this.getMassCore()
      // 声量趋势数据
      if (item.id === 'brand') {
        const compareItem = this.volumnFormArr.find(item => item.id === 'searchStr') || {}
        const volumnBindValue = JSON.parse(JSON.stringify(this.volumnBindValue))
        volumnBindValue.searchStr = [[compareItem.children[0].id, value || '']]
        this.volumnChange(volumnBindValue, compareItem, value)
      } else {
        this.getVoiceTrend()
      }
      // 获取产线分析数据
      this.refreshList()
    },
    // 核心指标接口
    getMassCore() {
      this.$set(this.isLoading, 0, true)
      getMassCore(this.getParam()).then(data => {
        this.$set(this.isLoading, 0, false)
        const res = data.data || {}
        this.indicatorsList = this.indicatorsList.map(item => {
          item.sum = res[item.sumKey]
          item.rate = res[item.rateKey]
          return item
        })
      })
    },
    // 绘制声量趋势
    getVoiceTrend() {
      this.$set(this.isLoading, 1, true)
      // 特殊处理时间参数
      const param = this.paramTimeHandle(this.getParam())
      this.overSearchStr = JSON.parse(JSON.stringify(this.volumnBindValue.searchStr || []))
      // 处理对比指标
      const searchStr = this.volumnBindValue.searchStr.reduce((preArr, item) => {
        preArr.push({
          platform: item[0],
          brand: item[1]
        })
        return preArr
      }, [])
      // 开始请求接口
      getVoiceTrend(Object.assign(param, {
        selectType: this.volumnBindValue.selectType,
        searchStr: searchStr
      })).then(res => {
        this.$set(this.isLoading, 1, false)
        const selectType = this.volumnFormArr[0].children.find(item => item.id === this.volumnBindValue.selectType) || {}
        // x轴的值
        const xData = []
        // y轴对应series值
        const seriesData = JSON.parse(JSON.stringify(pageConfig.volumnSeriesData))
        seriesData[0].name = selectType.name || '总互动量'
        const colorArr = ['#FFB600', '#ED9E6E', '#FFBC22']
        this.volumnBindValue.searchStr.forEach((elem, i) => {
          // const name = elem.join('-').replace('小红书', '小红书指数')
          const name = elem.join('-')
          seriesData.push({
            name: name,
            type: 'line',
            data: [],
            itemColor: colorArr[i % 3],
            yAxisIndex: 1,
            key: elem.join('-')
          })
        })
        const dataList = (res.data || []).map(item => {
          const obj = (item.indexs || []).reduce((preObj, elem) => {
            preObj[elem.name] = elem.indexCnt
            return preObj
          }, {})
          delete item.indexs
          return Object.assign(item, obj)
        })
        const xKey = 'dataTime'
        dataList.forEach(item => {
          const xValue = item[xKey]
          xData.push({
            value: param.timeType * 1 === 0 ? xValue.substr(0, 7) : xValue,
            textStyle: {
              fontSize: 14,
              lineHeight: 24
            }
          })
          seriesData.forEach((seriesItem, index) => {
            seriesItem.data.push({
              value: item[seriesItem.key] ? item[seriesItem.key] * 1 : 0,
              xdata: item[xKey]
            })
          })
        })
        this.$nextTick(() => {
          // 定义值只显示几条柱子
          const dataZoomLg = 31
          const xAxis = this.$chart.getXAxis(xData)
          const yAxis = [
            {
              name: selectType.name || '总互动量',
              axisLabel: {
                formatter: '{value}'
              }
            },
            {
              name: '指数',
              splitLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value}'
              }
            }
          ]
          const option = this.$chart.mixBarLineChart(xData, yAxis, seriesData, true, {
            show: dataList.length > dataZoomLg,
            dataZoomLg: dataZoomLg,
            bottom: 30,
            zoomLock: false,
            xAxisIndex: xAxis.length > 1 ? [0, 1] : [0]
          }, {
            top: 50,
            bottom: dataList.length > dataZoomLg ? 80 : 30
          }, {
            top: 10,
            itemGap: 40
          }, xAxis)
          // 图形销毁重新绘制
          document.getElementById('volumn-tren-line-chart').removeAttribute('_echarts_instance_')
          // 重新绘制,重新加载数据
          const myChart = this.$echarts.init(document.getElementById('volumn-tren-line-chart'))
          myChart.setOption(option, true)
          // 根据屏幕的大小来缩放
          window.onresize = () => {
            myChart.resize()
          }
        })
      })
    },
    // 声量选择
    volumnChange(bindForms, item, value) {
      if (item.id === 'searchStr' && bindForms.searchStr.length > 2) {
        this.volumnBindValue.searchStr = this.overSearchStr
        this.$message({
          duration: 3000,
          type: 'warning',
          message: '最多只能选择两个对比对象'
        })
        return
      }
      this.volumnBindValue = bindForms
      this.getVoiceTrend()
    },
    // 获取排序指标
    getSortLabel() {
      getSortLabel().then(res => {
        this.sortIndex = $filterCommon.getDataHandle(res.data || [], 'labelName', 'name')
        this.pageObj.sortIndex = this.sortIndex.length ? this.sortIndex[0].id : ''
      })
    },
    // 获取产线分析数据
    getList(currentPage, pageSize) {
      this.$set(this.isLoading, 2, true)
      this.pageObj.page = currentPage || 1
      pageSize && (this.pageObj.pageSize = pageSize)
      this.pageList = []
      getList(Object.assign(this.getParam(), {
        startPageNum: this.pageObj.page,
        pageSize: this.pageObj.pageSize,
        sortItem: this.pageObj.sortIndex,
        isSortMax: this.pageObj.sortRule
      })).then(res => {
        this.$set(this.isLoading, 2, false)
        this.pageList = (res.data || []).map((item, index) => {
          item.$index = index + 1
          return item
        })
      })
    },
    // 获取产线分析数据总数
    getListTotal() {
      this.pageObj.totalSize = -1
      getListTotal(this.getParam()).then(res => {
        this.pageObj.totalSize = res.data || 0
      })
    }
  }
}
</script>

<style lang="less">
@import '~@/assets/less/color.less';
.form-item-searchStr-box{
  & .el-cascader{
    width: 350px;
  }
  & .el-radio__input.is-checked .el-radio__inner{
    background: #fff;
    border: 2px solid @color-orange;
  }
  & .el-radio__input.is-checked .el-radio__inner::after{
    background-color: @color-orange;
  }
}
.form-item-quota-box .el-radio__input.is-checked+.el-radio__label,
.form-item-searchStr-box .el-radio__input.is-checked+.el-radio__label{
  color: #666;
}
</style>
<style lang="less" scoped>
@import '~@/assets/less/color.less';
.wrap-overview{
  & .chart-box{
    height: 400px;
  }
  & .volumn-filter-box{
    top: -53px;
    left: 15%;
    z-index: 2;
    & .volumn-list-filter{
      padding-top: 0px;
    }
  }
}
</style>
